import * as NUMBER from 'constant/number'
import * as FIELD_NAME from 'constant/form-item-names'
import * as RULES from 'constant/form-rules'
import * as FIELD_LABEL from 'constant/form-labels'
import { connect } from 'react-redux'
import { TreeSelect, Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'

const { SHOW_ALL } = TreeSelect

const CategorySelect = ({ categories, hidden = false }) => {
  const options = getOptions(categories)
  const handleDraftUpdate = (prevValues, currentValues) => prevValues.is_draft !== currentValues.is_draft
  return (
    <>
      <Form.Item
        noStyle
        shouldUpdate={handleDraftUpdate}
      >
        {({ getFieldValue }) => {
          const draft = getFieldValue(FIELD_NAME.DRAFT)
          return (
            <>
              <span>{FIELD_LABEL.CATEGORY_SELECT}</span>
              <Form.Item
                hidden={hidden}
                name={FIELD_NAME.CATEGORY_UUID}
                rules={draft ? [] : [RULES.REQUIRED]}
              >
                <TreeSelect
                  allowClear
                  bordered={false}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  getPopupContainer={trigger => trigger.parentNode}
                  maxTagCount={NUMBER.TEN}
                  multiple
                  placeholder={'Categories'}
                  showCheckedStrategy={SHOW_ALL}
                  showSearch={false}
                  size='large'
                  style={{ background: '#fff' }}
                  treeCheckable
                  treeData={options}
                />
              </Form.Item>
            </>)
        }}
      </Form.Item>

    </>
  )
}

const getOptions = (categories) =>
  Object.values(
    categories
      .reduce((result, category) => {
        const site = result[category.site_uuid] || (
          result[category.site_uuid] = {
            checkable: false,
            children: [],
            key: category.site_uuid,
            selectable: false,
            title: category.site_name,
            value: category.site_uuid
          })

        site.children.push({
          children: category.sub_categories.map((subCategory) => ({
            key: subCategory.uuid,
            title: subCategory.name,
            value: subCategory.uuid
          })),
          key: category.uuid,
          title: category.name,
          value: category.uuid
        })

        return result
      }, {})
  )

CategorySelect.propTypes = {
  categories: PropTypes.array,
  category: PropTypes.string,
  handleChange: PropTypes.func,
  hidden: PropTypes.bool
}

const mapStateToProps = (state) => ({
  categories: state.category.managementCategories
})

export default connect(mapStateToProps)(CategorySelect)
